import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ContentReviewPage from "@/pages/admin/ContentReviewPage";

export const Route = createFileRoute("/_admin/admin/content")({
  head: () => pageHead("Admin · Content", "AKIVA admin · content portal.", "/admin/content", true),
  component: ContentReviewPage,
});
